import ActionInput from 'automation-ui-action-features/action-inputs/records/ActionInput';
import { Map as ImmutableMap, List, Record } from 'immutable';
export default class JsonSchema extends Record({
  schemaType: 'OBJECT',
  schemas: null,
  variable: null,
  children: null
}, 'JsonSchema') {
  constructor(props = {}) {
    let propMap = ImmutableMap(props);
    const schemaType = propMap.get('schemaType') || 'OBJECT';
    const schemas = propMap.get('schemas');
    const variable = propMap.get('variable');
    const children = ImmutableMap(propMap.get('children'));
    propMap = propMap.set('schemaType', schemaType);
    if (schemaType === 'OBJECT') {
      const mappedChildren = children.reduce((acc, value, key) => {
        return acc.set(key, new JsonSchema(value));
      }, ImmutableMap());
      propMap = propMap.set('children', mappedChildren);
    } else if (schemaType === 'ARRAY') {
      propMap = propMap.set('schemas', List(schemas.map(schema => new JsonSchema(schema))));
    } else if (schemaType === 'LEAF') {
      propMap = propMap.set('variable', new ActionInput(variable));
    }
    super(propMap);
  }
  getSchemaType() {
    return this.get('schemaType');
  }
  getSchemas() {
    return this.get('schemas');
  }
  setSchemas(newSchema) {
    return this.set('schemas', newSchema);
  }
  getVariable() {
    return this.get('variable');
  }
  setVariable(variable) {
    return this.set('variable', variable);
  }
  getChildren() {
    return this.get('children');
  }
  setChildren(newChildren) {
    return this.set('children', newChildren);
  }
}